/**
 * Recommendations View - Full-page FAIR Implementation Planner
 *
 * Per design document: Recommendations_UX_Design_v2.0_FINAL.md
 * - Full-page three-panel layout (Filters 280px, Grid flex, Detail 480px)
 * - Category-based grouping (Critical Issues, Optimizations, Best Practices, Future)
 * - Evidence provenance tracking
 * - Strategic triage workflow
 */

import React from 'react';
import { useParams } from 'react-router-dom';
import { RecommendationList } from '../../components/RecommendationList';

export const RecommendationsView: React.FC = () => {
  const { group_id } = useParams<{ group_id: string }>();

  if (!group_id) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h2>Error: Missing Journey ID</h2>
        <p>Please navigate to this page from a journey.</p>
      </div>
    );
  }

  // RecommendationList component handles everything (per design doc Phase 1)
  return <RecommendationList groupId={group_id} />;
};
